import { CustomCheckbox } from '../../../../../components/CustomCheckbox';
import { CustomAddChip } from '../../../../../components/CustomAddChip';
import AllergensApp from '../Functionality/AllergensApp';
import { Diets } from '../../../../../enums/FoodieIcons';
import DividerWithText from '../../../../../components/DividerWithText';
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 *
 */
const Allergens = ({
    t,
    allergens,
    dietType = [],
    selectedAllergens,
    setSelectedAllergens,
    selectedDietTypes,
    setSelectedDietTypes,
    disabled,
    handleDietTypeDelete,
    handleAllergenDelete,
    emptyFields,
    permissionUpdate
}) => {
    const { dietTypesAll, handleDietTypeChange, allergenOptions } = AllergensApp(
        dietType,
        allergens,
        setSelectedDietTypes,
        selectedDietTypes,
        setSelectedAllergens,
        handleDietTypeDelete,
    );
    return (
        <>
            <span className='ibl-font-w-600 ibl-description '>{t('select_the_food_present_in_the_dish_or_the_type_of_diet').toUpperCase()}</span>
            <div className='row pt-3'>
                {dietTypesAll.map((diet) => (
                    <div key={diet.id} className='col-sm-12 col-md-4 col-lg-4 col-xl-4 mb-0 ms-0 pt-0 px-0'>
                        <CustomCheckbox
                            id={`cb_a_select_all_${diet.id}`}
                            className='mt-0'
                            label={diet.name}
                            trans={t(Diets[diet.id].name)}
                            value={diet.id}
                            marginbutton={true}
                            disabled={disabled}
                            checked={
                            Array.isArray(selectedDietTypes) &&
                            selectedDietTypes.some(
                                (item) => (typeof item === 'object' ? item.id : item) === diet.id,
                            )
                            }
                            onChange={() => handleDietTypeChange(diet.id, diet.name)}
                        />
                    </div>
                ))}
            </div>
            <div className='mt-4'>
                <DividerWithText title={t('allergens')} />
            </div>
            <div className='mb-5 mt-4'>
                {Array.isArray(allergenOptions) && (
                    <CustomAddChip
                        autocompleteId={'slt_a_allergens'}
                        buttonId={'btn_a_add_allergens'}
                        label='allergens'
                        disabled={disabled}
                        data={(allergenOptions || []).map((item) => ({
                            ...item,
                            subSection: () => null,
                        }))}
                        selectedList={
                            Array.isArray(selectedAllergens)
                                ? selectedAllergens.map((item) => ({
                                      ...item,
                                      subSection: () => null,
                                  }))
                                : []
                        }
                        setSelectedList={setSelectedAllergens}
                        required={true}
                        onDeleteItem={permissionUpdate ? handleAllergenDelete : undefined}
                        emptyFields={emptyFields}
                        chipIcon={null}
                        reset={false}
                    />
                )}
            </div>
        </>
    );
};

export default Allergens;
